<div class="pedido-nao-liberado-card-info-bonificacao-excedente card card-warning">
    <div class="card-header">
        <p class="card-title mb-0">
            <i class="fas fa-exclamation-triangle"></i> {{tipoVenda | pedidoTipoVenda}} Excedente
        </p>
    </div>
    <ul class="list-group list-group-flush list-group-vertical">
        <li class="list-group-item">
            <span class="list-group-item-title">
                Motivo da Não Liberação
            </span>
            <span class="list-group-item-value">
                Este {{tipoVenda | pedidoTipoVendaSinonimo}} não foi liberado por que o percentual bonificado excedeu o percentual limite de bonificação da campanha selecionada
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Não Liberado em
            </span>
            <span class="list-group-item-value">
                {{dataNaoLiberado | date: 'dd/MM/yyyy'}} às {{dataNaoLiberado | date: 'HH:mm'}}
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Campanha
            </span>
            <span class="list-group-item-value">
                {{campanha?.nome}}
            </span>            
        </li>
        <li class="list-group-item regra">
            <span class="list-group-item-title">
                Regra
            </span>
            <span class="list-group-item-value">
                Pedidos de venda referenciados
                <br/>
                <small>
                    Valor total dos pedidos de vendas referenciados
                </small>
            </span>
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Valor pedidos de venda referenciados
            </span>
            <span class="list-group-item-value">
                {{valorRegraNaoLiberado | currencyFormat: 1:2:2}}
            </span>
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Valor bonificado
            </span>
            <span class="list-group-item-value">
                {{valorBonificacaoNaoLiberado | currencyFormat: 1:2:2}}
            </span>
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Percentual limite bonificação
            </span>
            <span class="list-group-item-value">
                {{percBonificacaoMaximaNaoLiberado | decimalFormat: 1:2:2}}%
            </span>
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Percentual bonificado
            </span>
            <span class="list-group-item-value">
                {{percBonificacaoNaoLiberado | decimalFormat: 1:2:2}}% ({{percBonificacaoExcedente | decimalFormat: 1:2:2}}% a mais)
            </span>
        </li>
    </ul>
</div>